import React from "react";
import Modal from "../../../Layout/Shared/Modal";
import "../../../../styles/customComponents/shared.scss";
import "../index.scss";
import SuccessBlue from "../../../../assets/images/big-success-blue.png";

export const ImportSuccess = ({onClose, onConfirm, refresh, importResult}) => {
  const {inserted = 0, skipped = 0} = importResult || {};

  return (
    <Modal
      title="Import Contact"
      width="718px"
      height="430px"
      close={() => {
        onClose();
        refresh();
      }}
    >
      <div className="d-flex align-items-center flex-column">
        <div>
          <img src={SuccessBlue} alt="" />
        </div>
        <span className="h1 mt-5 text-primary-blue">
          <strong>SUCCESS!</strong>
        </span>
        <p className="mt-5">
          <strong>{inserted}</strong> contact(s) imported successfully.
          {skipped > 0 && (
            <span className="text-muted">
              {" "}({skipped} duplicate(s) skipped)
            </span>
          )}
        </p>
        <button
          className="mt-3 btn-blue btn-small"
          onClick={() => {
            onClose();
            onConfirm();
            refresh();
          }}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};
